import { render, staticRenderFns } from "./ProfilingOverview.vue?vue&type=template&id=32e38838&scoped=true"
import script from "./ProfilingOverview.vue?vue&type=script&lang=js"
export * from "./ProfilingOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e38838",
  null
  
)

export default component.exports